import localAxios from '../../localAxios';
import { workspaceQuizLockURL } from '../workspacesURLs';

interface QuickLockQuizId {
  quizId: number;
}

interface PostWorkspaceQuizLockResponse {
  httpStatus: number;
  message: string;
  data: QuickLockQuizId;
}

export async function postWorkspaceQuizLock({
  workspaceId,
  workspaceQuizId,
}: {
  workspaceId: string;
  workspaceQuizId: string;
}) {
  const url = workspaceQuizLockURL({
    workspaceId,
    workspaceQuizId,
  });
  const result = await localAxios.post<PostWorkspaceQuizLockResponse>(url.href);

  const {
    data: { data },
  } = result;

  return data;
}
